import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fleetManager: {},
};

export const fleetManagerSlice = createSlice({
  name: "fleetManager",
  initialState,
  reducers: {
    setFleetManager: (state, action) => {
      state.fleetManager = action.payload.fleetManager;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFleetManager } = fleetManagerSlice.actions;
export const getFleetManager = (state) => {
  return state.fleetManager.fleetManager;
};

export default fleetManagerSlice.reducer;
